import React, { useRef, useEffect, useState } from "react";
import StandardModal from "../shared/Modal/StandardModal";
import { useAuth } from "../../context/AuthContext";
import { getApiEndpoint } from "../../config/config";
import DisplayMessage from "../shared/DisplayMessage/DisplayMessage";

function MarkColdModal({ isOpen, onClose, recruit, onConfirmMarkCold }) {
  const markColdButtonRef = useRef(null);
  const { getVerifiedJWT } = useAuth();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && markColdButtonRef.current) {
      // Small delay to ensure modal is fully rendered
      const timer = setTimeout(() => {
        markColdButtonRef.current.focus();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleMarkCold = async () => {
    if (!recruit || isProcessing) return;

    try {
      setIsProcessing(true);
      setError(null);

      const jwt = await getVerifiedJWT();
      if (!jwt) {
        setError("Authentication failed");
        return;
      }

      const response = await fetch(
        getApiEndpoint(`/v1/recruiting/leads/${recruit.id}/status`),
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
          body: JSON.stringify({ status: "Cold" }),
        }
      );

      if (response.ok) {
        if (onConfirmMarkCold) {
          onConfirmMarkCold();
        }
        onClose(); // Close the modal on success
      } else {
        const errorData = await response.json().catch(() => ({}));
        setError(errorData.message || "Failed to mark as cold");
      }
    } catch (err) {
      setError("Failed to mark as cold");
    } finally {
      setIsProcessing(false);
    }
  };

  if (!recruit) return null;

  return (
    <StandardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Mark as Cold"
      footerLeft={
        <button
          className="btn btn-md btn-secondary"
          onClick={onClose}
          disabled={isProcessing}
        >
          Cancel
        </button>
      }
      footerRight={
        <button
          ref={markColdButtonRef}
          className="btn btn-md btn-primary"
          onClick={handleMarkCold}
          disabled={isProcessing}
        >
          {isProcessing ? "Processing..." : "Mark as Cold"}
        </button>
      }
    >
      <div>
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <div style={{ marginBottom: "1rem" }}>
            <span
              className="material-icons"
              style={{
                fontSize: "3rem",
                color: "#60A5FA",
                display: "block",
                marginBottom: "0.5rem",
              }}
            >
              ac_unit
            </span>
          </div>
          <p style={{ fontSize: "1.1rem", marginBottom: "0.5rem" }}>
            Are you sure you want to mark <strong>{recruit.name}</strong> as
            cold?
          </p>
          <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>
            They will be moved to your cold list and removed from the active
            pipeline.
          </p>
          {error && (
            <div style={{ marginTop: "1rem" }}>
              <DisplayMessage type="error" message={error} />
            </div>
          )}
        </div>
      </div>
    </StandardModal>
  );
}

export default MarkColdModal;
